require('../modules/es.global-this');

module.exports = require('../internals/global');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/node_modules/core-js-pure/es/global-this.js
// module id = dW6w
// module chunks = 0